import React from 'react'
import ReactDOM from 'react-dom/client'
import RegistrationForm from './App'
// Import styles
import './styles.css'

// Create and mount the app when the script loads
function initialize() {
  const container = document.createElement('div');
  container.id = 'affiliate-registration-app';
  document.currentScript.parentElement.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    React.createElement(RegistrationForm)
  );
}

// Initialize when the script loads
initialize();

// Make mount function available globally
window.mountAffiliateRegistration = initialize;

// Don't auto-mount - let the Shopify section handle it
